import { Coffee, ArrowUpRight } from "lucide-react";
import { CTA } from "@/lib/config";

export default function FundProjectCTA() {
  return (
    <div
      data-testid="fund-project-cta"
      className="mt-8 border border-yellow-500/50 bg-yellow-500/10 dark:bg-yellow-500/5 p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4"
    >
      <div className="w-12 h-12 shrink-0 bg-yellow-500 text-black grid place-items-center">
        <Coffee className="w-6 h-6" strokeWidth={2.5} />
      </div>
      <div className="flex-1">
        <div className="font-display font-bold text-lg text-zinc-900 dark:text-white">
          Fund this project · Buy us a coffee
        </div>
        <p className="mt-1 text-sm text-zinc-700 dark:text-zinc-300 leading-relaxed">
          So we can fund a detailed{" "}
          <span className="font-semibold text-yellow-700 dark:text-yellow-500">
            AI analysis
          </span>{" "}
          on your ad campaign — hooks, CTA, sentiment, and audience fit. Free
          tool stays free; coffee fuels the upgrade.
        </p>
      </div>
      <a
        href={CTA.buyCoffee}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="fund-project-buy-coffee-btn"
        className="group inline-flex items-center gap-2 bg-black hover:bg-zinc-800 text-yellow-500 font-bold text-sm h-11 px-5 transition-all hover:-translate-y-0.5 w-full md:w-auto justify-center"
      >
        <Coffee className="w-4 h-4" strokeWidth={2.5} />
        Buy us a coffee
        <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
      </a>
    </div>
  );
}
